import { render, staticRenderFns } from "./ErrorLogin-comp.vue?vue&type=template&id=4032ef39&scoped=true&"
import script from "./ErrorLogin-comp.vue?vue&type=script&lang=js&"
export * from "./ErrorLogin-comp.vue?vue&type=script&lang=js&"
import style0 from "./ErrorLogin-comp.vue?vue&type=style&index=0&id=4032ef39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4032ef39",
  null
  
)

export default component.exports